export default __webpack_public_path__ + "static/media/finishingblow.ca67f47e.png";